import { render, staticRenderFns } from "./lkuKoranKiriman.vue?vue&type=template&id=1dba1449"
import script from "./lkuKoranKiriman.vue?vue&type=script&lang=js"
export * from "./lkuKoranKiriman.vue?vue&type=script&lang=js"
import style0 from "./lkuKoranKiriman.vue?vue&type=style&index=0&id=1dba1449&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports